export interface INewsOptions {
  page: number;
  size: number;
  lang: string;
  dateRange?: {
    gte: number;
    lte: number;
  };
}

export interface INewsResponse {
  news: INews[];
  total: number;
}

export interface INews {
  id: string;
  title: string;
  description: string;
  url: string;
  imageURL: string;
  publishedAt: number;
  language: string;
  source: string;
  provider: string;
}

export interface INewsState {
  news: INews[];
  page: number;
  size: number;
  lang: string;
  total: number;
  selectedArticle: string;
  isLoading: boolean;
  isDeleting: boolean;
  toggleModal: boolean;
  hasMore: boolean;
}

export const initialNewsState: INewsState = {
  news: [],
  page: 0,
  size: 20,
  lang: "en",
  total: 0,
  selectedArticle: "",
  isLoading: true,
  isDeleting: false,
  toggleModal: false,
  hasMore: true
};



// WEBPACK FOOTER //
// ./src/share/types/news.ts